/**
 * Miniature SVG sparkline. `points` = array of numbers.
 * `tone` = "ink"|"gold"|"coral"|"green"|"red"|"amber"|"indigo" — controls stroke color.
 * "gold" is kept as an alias for backwards compatibility; it now renders coral.
 */
const STROKE = {
  ink: "var(--cf-ink)",
  coral: "url(#cf-spark-coral)",
  gold: "url(#cf-spark-coral)",
  green: "#10B981",
  red: "#EF4444",
  amber: "#F59E0B",
  indigo: "#818CF8",
};

export default function Sparkline({ points, width = 92, height = 26, tone = "ink" }) {
  if (!points || points.length === 0) {
    return <span className="text-muted-light text-xs">–</span>;
  }
  const max = Math.max(...points, 1);
  const min = Math.min(...points, 0);
  const range = max - min || 1;
  const step = width / Math.max(points.length - 1, 1);
  const coords = points.map((v, i) => {
    const x = i * step;
    const y = height - ((v - min) / range) * (height - 2) - 1;
    return [x, y];
  });
  const d = coords.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  const last = coords[coords.length - 1];
  const stroke = STROKE[tone] || STROKE.ink;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="block">
      <defs>
        <linearGradient id="cf-spark-coral" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#E11D48" />
          <stop offset="50%" stopColor="#F43F5E" />
          <stop offset="100%" stopColor="#FB7185" />
        </linearGradient>
      </defs>
      <path
        d={d}
        fill="none"
        stroke={stroke}
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {last && (
        <circle
          cx={last[0]}
          cy={last[1]}
          r={2.2}
          fill={tone === "gold" || tone === "coral" ? "#F43F5E" : stroke}
        />
      )}
    </svg>
  );
}
